import React, { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Loader2 } from "lucide-react";

export const inr = (v) => (v != null && v !== "" ? `₹ ${Number(v).toLocaleString("en-IN")}` : "—");
export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString("en-IN", { dateStyle: "medium" }) : "—");
export const cap = (s) => (s ? s[0].toUpperCase() + s.slice(1) : s);
export const DEFAULT_STATUSES = ["new", "contacted", "interested", "converted", "dropped"];
const STATUS_TONE = {
  new: "bg-slate-100 text-slate-800 border-slate-200", contacted: "bg-blue-50 text-blue-800 border-blue-200",
  interested: "bg-amber-50 text-amber-800 border-amber-200", converted: "bg-emerald-50 text-emerald-800 border-emerald-200",
  dropped: "bg-red-50 text-red-700 border-red-200",
};

export function StatusSelect({ item, statuses, onChange, testIdPrefix = "loan-lead-status" }) {
  return (
    <select value={item.status} onChange={(e) => onChange(item, { status: e.target.value })}
      className={`h-8 rounded-md border px-2 text-xs font-medium ${STATUS_TONE[item.status] || STATUS_TONE.new}`} aria-label="Follow-up status" data-testid={`${testIdPrefix}-${item.id}`}>
      {statuses.map((s) => <option key={s} value={s}>{cap(s)}</option>)}
    </select>
  );
}

export function NotesDialog({ item, subtitle, onClose, onSave, testIdPrefix = "loan-lead-notes" }) {
  const [notes, setNotes] = useState(item?.notes || "");
  const [busy, setBusy] = useState(false);
  useEffect(() => { setNotes(item?.notes || ""); }, [item]);
  if (!item) return null;
  const save = async () => { setBusy(true); await onSave(item, { notes }); setBusy(false); onClose(); };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-md" data-testid={`${testIdPrefix}-dialog`}>
        <DialogHeader><DialogTitle>Notes — {item.customer_name}</DialogTitle></DialogHeader>
        {subtitle && <p className="text-xs text-slate-500">{subtitle}</p>}
        <Textarea rows={5} value={notes} onChange={(e) => setNotes(e.target.value)} placeholder="Call outcome, best time to reach, documents needed…" data-testid={`${testIdPrefix}-input`} />
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Cancel</Button>
          <Button onClick={save} disabled={busy} className="bg-slate-950 hover:bg-slate-800" data-testid={`${testIdPrefix}-save`}>{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Save notes"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
